module.exports = __webpack_public_path__ + "static/img/perecent7.52da8b03.png";